import { RefObject, useEffect } from 'react';

type Event = MouseEvent | TouchEvent;

interface useOutsideClickHookInterface {
    ref: RefObject<HTMLElement>;
    noTargetRefArray?: RefObject<HTMLElement>[];
    callback: (e: Event) => void;
}

type useOutsideClickHookType = (args: useOutsideClickHookInterface) => void;

export const useOutsideClickHook: useOutsideClickHookType = ({ ref, noTargetRefArray, callback }) => {
    const listener = (event: Event) => {
        const element = ref?.current;

        const checkContains = () => {
            return noTargetRefArray?.some((elem: RefObject<HTMLElement>) => {
                return elem?.current?.contains(event.target as Node);
            });
        };

        if (!element || element.contains(event.target as Node) || checkContains()) {
            return;
        }
        callback(event);
    };

    useEffect(() => {
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);

        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref?.current, callback]);
};
